import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedKeys:'',
    openKeys:[],
    login:{},
    loginStatus:false,
    TableLoading:false,
    params:{
      informationDetails:{}
    },
    isChangeNum:false,
  },
  getters: {
  },
  mutations: {
    update(state,data){
      if(data){
        state.login = data
        state.loginStatus = true
      }
    },
    //[2026-09-03] 退出登录或登录态失效时重置登录状态。
    logout(state){
      state.login = {}
      state.loginStatus = false
    }
  },
  actions: {
  },
  modules: {
  }
})
